import { Box, FormControl, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as jwtDecode from "jwt-decode";
import { useNavigate, useParams } from "react-router-dom";

import { useState } from "react";
import { PasswordIcon } from "../../assets/Icon/singUpIcon";
import { resetPasswordSchema } from "../../form-schema";
import { resetPassword } from "../../stores/auth";
import { ResetPassPayload } from "../../stores/auth/Interface";
import { useAppDispatch } from "../../stores/store";
import { setToast } from "../../stores/toast/toastslice";
import theme from "../../theme";
import CustomButton from "../common-components/CustomButton";
import InputField from "../common-components/InputField";

const ResetForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { token } = useParams();
  const [emailMessage, setEmailMessage] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [loading, setLoading] = useState(false);

  // regex to detect email inside text
  const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;

  const o_id = localStorage.getItem("o_id");

  const getEmail = () => {
    if (token) {
      try {
        //@ts-ignore
        const decoded: { email?: string } = jwtDecode(token);
        return decoded.email || "";
      } catch (error) {
        return "";
      }
    } else {
      return localStorage.getItem("email") || "";
    }
  };

  const email = getEmail();

  const handleReset = async (values: ResetPassPayload) => {
    setLoading(true);

    try {
      const response = await dispatch<any>(resetPassword(values)).unwrap();

      if (response?.data.status === 1) {
        setLoading(false);
        localStorage.clear();
        setTimeout(() => {
          navigate("/login");
        }, 100);
        dispatch<any>(
          setToast({
            message: response.data.message,
            type: "success",
            title: "Success",
          })
        );
      } else {
        const message = response?.data?.message;
        setLoading(false);
        if (message?.match(emailRegex)?.[0]) {
          setAdminEmail(message?.match(emailRegex)?.[0]);
          setEmailMessage(message);
          return;
        }
        dispatch<any>(
          setToast({
            message: response.data.message,
            type: "error",
            title: "Error",
          })
        );
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      email: email,
      newPassword: "",
      confirmPassword: "",
      token: token || "",
      o_id: o_id || "",
    },
    validationSchema: resetPasswordSchema,
    onSubmit: (values) => {
      if (values.newPassword !== values.confirmPassword) {
        formik.setErrors({ confirmPassword: "Passwords do not match" });
        return;
      }
      handleReset({
        email: values.email,
        password: values.newPassword,
        token: values.token,
        o_id: values.o_id,
      });
    },
  });

  return (
    <>
      <div
        className="form-container "
        style={{
          maxWidth: "80%",
        }}
      >
        <div>
          <Typography
            variant="h1"
            className="logo-title"
            style={{ color: "#05000B", marginBottom: "20px" }}
          >
            {token ? "Set your password" : "Reset Password"}
          </Typography>
          <Typography
            variant="h3"
            className="logo-title1"
            sx={{
              color: "#6C6F71",
              wordWrap: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {token
              ? "Please create a secure password. This helps protect your account and ensure your data remains safe."
              : "Create a new password to regain secure access to your account.Ensure your new password is strong and unique."}
          </Typography>
        </div>
        {adminEmail?.length > 0 && (
          <Box
            sx={{
              textAlign: "start",
              marginTop: 1,
              lineHeight: "24px",
            }}
          >
            <a
              href={`mailto:${adminEmail}`}
              style={{
                color: "red",
                fontSize: "16px",
                textAlign: "start",
                textDecoration: "none",
                cursor: "pointer",
                fontWeight: 400,
              }}
            >
              {emailMessage?.replace(`${adminEmail}.`, "")}
              <span
                style={{
                  color: "red",
                  textDecoration: "underline",
                }}
              >
                {adminEmail}
              </span>
            </a>
          </Box>
        )}
        <form onSubmit={formik.handleSubmit}>
          <FormControl
            variant="standard"
            sx={{ width: "100%", paddingTop: "30px" }}
          >
            <>
              <Typography
                sx={{ color: theme.palette.myCustomColor.dark }}
                variant="h4"
              >
                New Password
              </Typography>
              <InputField
                formik={formik}
                margin="normal"
                name="newPassword"
                placeholder={"Enter password"}
                type="password"
                icon={<PasswordIcon />}
                minWidth=""
              />
              <Typography
                sx={{ color: theme.palette.myCustomColor.dark }}
                variant="h4"
              >
                Confirm Password
              </Typography>
              <InputField
                formik={formik}
                name="confirmPassword"
                margin="normal"
                placeholder={"Enter confirm password"}
                type="password"
                icon={<PasswordIcon />}
                minWidth=""
              />
            </>

            <CustomButton
              btnTitle={token ? "Save Password" : "Reset"}
              maxwidth="450px"
              type="submit"
              loading={loading}
            />
          </FormControl>
        </form>
      </div>
    </>
  );
};

export default ResetForm;
